import React from 'react';
import { ENUM_SORT_DIRECTION } from '../enums/enums';

export default function useSorting() {
  const sortText = (data, elName, sortDirection) => {
    if (sortDirection == ENUM_SORT_DIRECTION.asc) {
      return [...data].sort((a, b) => a[elName].localeCompare(b[elName]));
    } else {
      return [...data].sort((a, b) => b[elName].localeCompare(a[elName]));
    }
  };

  const sortNumeric = (data, elName, sortDirection) => {
    if (sortDirection == ENUM_SORT_DIRECTION.asc) {
      return [...data].sort((a, b) => a[elName] - b[elName]);
    } else {
      return [...data].sort((a, b) => b[elName] - a[elName]);
    }
  };

  const sortDate = (data, elName, sortDirection) => {
    if (sortDirection == ENUM_SORT_DIRECTION.asc) {
      return [...data].sort((a, b) => new Date(a[elName]) - new Date(b[elName]));
    } else {
      return [...data].sort((a, b) => new Date(b[elName]) - new Date(a[elName]));
    }
  };

  return { sortText, sortNumeric, sortDate };
}
